import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import LoadMoreGlobalItems from 'components/molecules/LoadMoreGlobalItems/LoadMoreGlobalItems';
import Alooma from 'services/alooma';
import { getGlobalItemsGroup } from 'store/myItems/store/selectors';
import { DEFAULT_PER_PAGE_GLOBAL_ITEMS_SEARCH } from 'consts/queries';
import useShowCompleteLastLineOfItems from 'hooks/useShowCompleteLastLineOfItems';
import { useCardTagRegularBreakpoints } from 'hooks/grid/useCardTagRegularBreakpoint';
import CardTagGlobalSearch from 'components/molecules/CardTagGlobalSearch/CardTagGlobalSearch';
import ItemsGrid from '../ItemsGrid/ItemsGrid';
import XPlatformBannerContainer from '../XPlatformBannerContainer/XPlatformBannerContainer';

const GlobalItemCardsSection = ({ myItems }) => {
  const breakpoints = useCardTagRegularBreakpoints();
  const globalItemsGroup = useSelector(getGlobalItemsGroup);
  const { items, slidesPerView } = useShowCompleteLastLineOfItems(myItems, breakpoints, globalItemsGroup.tagsLeft);

  const renderItems = useCallback(() => {
    const numOfItemsToShowBanner = slidesPerView * 2;

    if (items.length > numOfItemsToShowBanner) {
      const firstItems = items.slice(0, numOfItemsToShowBanner);
      const lastItems = items.slice(numOfItemsToShowBanner, items.length);

      return (
        <>
          {firstItems.map(tag => (
            <Alooma.TagIdContext.Provider key={tag.id} value={tag.id}>
              <Alooma.RuleIdContext.Provider value={tag.rule_id}>
                <CardTagGlobalSearch tag={tag} />
              </Alooma.RuleIdContext.Provider>
            </Alooma.TagIdContext.Provider>
          ))}
          <XPlatformBannerContainer page="search" />
          {lastItems.map(tag => (
            <Alooma.TagIdContext.Provider key={tag.id} value={tag.id}>
              <Alooma.RuleIdContext.Provider value={tag.rule_id}>
                <CardTagGlobalSearch tag={tag} />
              </Alooma.RuleIdContext.Provider>
            </Alooma.TagIdContext.Provider>
          ))}
        </>
      );
    }

    return items.map(tag => (
      <Alooma.TagIdContext.Provider key={tag.id} value={tag.id}>
        <Alooma.RuleIdContext.Provider value={tag.rule_id}>
          <CardTagGlobalSearch tag={tag} />
        </Alooma.RuleIdContext.Provider>
      </Alooma.TagIdContext.Provider>
    ));
  }, [items, slidesPerView]);

  if (!items?.length) {
    return null;
  }

  const fetchGlobalParams = {
    page: globalItemsGroup.page + 1,
    includeGlobal: true,
    includeUser: false,
    per_page: DEFAULT_PER_PAGE_GLOBAL_ITEMS_SEARCH,
  };

  return (
    <LoadMoreGlobalItems group={globalItemsGroup} fetchParams={fetchGlobalParams}>
      <ItemsGrid columns={slidesPerView}>{renderItems()}</ItemsGrid>
    </LoadMoreGlobalItems>
  );
};

export default GlobalItemCardsSection;
